module.exports = __webpack_public_path__ + "img/homeworks.f63d37da.svg";